import {B} from "../../build";
import type {ReactNode} from "react";
import React from "react";
import {Auth0Provider} from "@auth0/auth0-react";

export const Auth0RootWrapper: React.FC<{children?: ReactNode}> = ({children}) => {
    return <Auth0Provider
        domain={B.AUTH0_DOMAIN}
        clientId={B.AUTH0_CLIENT_ID}
        authorizationParams={{
            organization: B.AUTH0_ORGANIZATION,
        }}>
        {children}
    </Auth0Provider>
}
